
<header class="header">
    <button class="menu-burger" aria-label="Ouvrir le menu" (click)="toggleMenu()">
        <span></span><span></span><span></span>
    </button>
    <a href="/" class="logo" aria-label="Accueil YouPrice"></a>
    <nav class="desktop-nav" [class.open]="isMenuOpen">
        <ul>
            <li><a href="/forfaits-mobile-orange/">Forfaits réseau Orange</a></li>
            <li><a href="/forfaits-mobile-sfr/">Forfaits réseau SFR</a></li>
            <li><a href="/forfaits-mobile-bouygues/">Forfaits réseau Bouygues Télécom</a></li>
        </ul>
    </nav>
    <div class="header-icons">
        <a [href]="bsktUrl" class="icon-btn" aria-label="Panier">
            <div *ngIf="counter!='0'" class="circle">{{counter}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clip-path="url(#clip0_9330_19870)">
            <path d="M1.3667 1.3667H2.70003L4.47337 9.6467C4.53842 9.94994 4.70715 10.221 4.95051 10.4133C5.19387 10.6055 5.49664 10.7069 5.8067 10.7H12.3267C12.6301 10.6995 12.9244 10.5956 13.1607 10.4053C13.3971 10.215 13.5615 9.94972 13.6267 9.65337L14.7267 4.70003H3.41337M6.00016 14C6.00016 14.3682 5.70169 14.6667 5.3335 14.6667C4.96531 14.6667 4.66683 14.3682 4.66683 14C4.66683 13.6318 4.96531 13.3333 5.3335 13.3333C5.70169 13.3333 6.00016 13.6318 6.00016 14ZM13.3335 14C13.3335 14.3682 13.035 14.6667 12.6668 14.6667C12.2986 14.6667 12.0002 14.3682 12.0002 14C12.0002 13.6318 12.2986 13.3333 12.6668 13.3333C13.035 13.3333 13.3335 13.6318 13.3335 14Z" stroke="#1C1C1C" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_9330_19870">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        </a>
        <a href="https://espace-client.youprice.fr/connexion-espace-client" class="icon-btn" aria-label="Profil">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12.6668 14V12.6667C12.6668 11.9594 12.3859 11.2811 11.8858 10.781C11.3857 10.281 10.7074 10 10.0002 10H6.00016C5.29292 10 4.61464 10.281 4.11454 10.781C3.61445 11.2811 3.3335 11.9594 3.3335 12.6667V14M10.6668 4.66667C10.6668 6.13943 9.47292 7.33333 8.00016 7.33333C6.5274 7.33333 5.3335 6.13943 5.3335 4.66667C5.3335 3.19391 6.5274 2 8.00016 2C9.47292 2 10.6668 3.19391 10.6668 4.66667Z" stroke="#1C1C1C" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </a>
    </div>
</header>